import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function FollowModal({ closeFollowModal, creatorName, follow }) {
  const dialog = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    dialog.current?.showModal?.();
    return () => previousFocus?.focus();
  }, []);
  const act = async () => { if (await follow.toggle()) closeFollowModal(false); };
  return createPortal(<dialog ref={dialog} className="creator-options-dialog" aria-label={`Options for ${creatorName}`} onCancel={() => closeFollowModal(false)} onClick={event => { if (event.target === event.currentTarget) closeFollowModal(false); }}>
    <div className="creator-options-content">
      <button type="button" className="creator-options-close" aria-label="Close creator options" onClick={() => closeFollowModal(false)}>×</button>
      <h2>{creatorName}</h2>
      <button type="button" disabled={!follow.loaded || follow.pending} onClick={act}>{follow.pending ? 'Saving…' : follow.following ? 'Unfollow' : 'Follow'}</button>
      {follow.error && <p role="alert">{follow.error}</p>}
      {!follow.loaded && follow.error && <button type="button" onClick={follow.retry}>Try again</button>}
    </div>
  </dialog>, document.body);
}
